/**
 * @generated SignedSource<<c1f3422f4ba73b4953211cb9841fc397>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfileCardRelay_query$data = {
  readonly activity: {
    readonly workedOn: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly object: {
            readonly data: {
              readonly __typename: "AssetsObject";
              readonly links: {
                readonly web: string | null;
              } | null;
            } | {
              readonly __typename: "AssetsObjectType";
              readonly links: {
                readonly web: string | null;
              } | null;
            } | {
              readonly __typename: "AssetsSchema";
              readonly links: {
                readonly web: string | null;
              } | null;
            } | {
              readonly __typename: "BitbucketPullRequest";
              readonly href: AGG$URL | null;
            } | {
              readonly __typename: "CompassComponent";
              readonly url: string | null;
            } | {
              readonly __typename: "ConfluenceBlogPost";
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceDatabase";
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceEmbed";
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceFooterComment";
              readonly container: {
                readonly __typename: "ConfluenceBlogPost";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                readonly __typename: "ConfluencePage";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                readonly __typename: "ConfluenceWhiteboard";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                // This will never be '%other', but we need some
                // value in case none of the concrete values match.
                readonly __typename: "%other";
              } | null;
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceInlineComment";
              readonly container: {
                readonly __typename: "ConfluenceBlogPost";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                readonly __typename: "ConfluencePage";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                readonly __typename: "ConfluenceWhiteboard";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                // This will never be '%other', but we need some
                // value in case none of the concrete values match.
                readonly __typename: "%other";
              } | null;
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluencePage";
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceWhiteboard";
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "DevOpsDesign";
              readonly webUrl: AGG$URL | null;
            } | {
              readonly __typename: "DevOpsDocument";
              readonly webUrl: AGG$URL | null;
            } | {
              readonly __typename: "DevOpsPullRequestDetails";
              readonly url: string | null;
            } | {
              readonly __typename: "ExternalDocument";
              readonly url: string | null;
            } | {
              readonly __typename: "ExternalPullRequest";
              readonly url: string | null;
            } | {
              readonly __typename: "ExternalRemoteLink";
              readonly url: string | null;
            } | {
              readonly __typename: "JiraIssue";
              readonly webUrl: AGG$URL | null;
            } | {
              readonly __typename: "JiraPlatformComment";
              readonly issue: {
                readonly webUrl: AGG$URL | null;
              } | null;
              readonly webUrl: AGG$URL | null;
            } | {
              readonly __typename: "JiraServiceManagementComment";
              readonly issue: {
                readonly webUrl: AGG$URL | null;
              } | null;
              readonly webUrl: AGG$URL | null;
            } | {
              readonly __typename: "LoomVideo";
              readonly loomUrl: string;
            } | {
              readonly __typename: "MercuryFocusArea";
              readonly url: string | null;
            } | {
              readonly __typename: "MercuryPortfolio";
              readonly url: string | null;
            } | {
              readonly __typename: "RadarPosition";
              readonly url: string | null;
            } | {
              readonly __typename: "RadarView";
              readonly url: string | null;
            } | {
              readonly __typename: "TownsquareComment";
              readonly url: string | null;
            } | {
              readonly __typename: "TownsquareGoal";
              readonly url: string | null;
            } | {
              readonly __typename: "TownsquareProject";
              readonly url: string | null;
            } | {
              readonly __typename: "TrelloBoard";
              readonly trelloUrl: AGG$URL | null;
            } | {
              readonly __typename: "TrelloCard";
              readonly trelloUrl: AGG$URL | null;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null;
          };
        };
      }>;
    };
  } | null;
  readonly knowledgeDiscovery?: {
    readonly singleUser: {
      readonly __typename: "KnowledgeDiscoverySingleUser";
      readonly user: {
        readonly manager: {
          readonly id: string | null;
          readonly jobTitle: string | null;
          readonly name: string | null;
          readonly picture: string | null;
        } | null;
        readonly thirdPartyIntegrations: ReadonlyArray<{
          readonly externalId: string;
          readonly integrationId: string;
          readonly product: string;
        }> | null;
      } | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
  readonly user: {
    readonly accountId: string;
    readonly appType?: string | null;
    readonly email?: string | null;
    readonly extendedProfile?: {
      readonly department: string | null;
      readonly jobTitle: string | null;
      readonly location: string | null;
      readonly organization: string | null;
    } | null;
    readonly name: string;
    readonly picture: AGG$URL;
  } | null;
  readonly " $fragmentType": "UserProfileCardRelay_query";
};
export type UserProfileCardRelay_query$key = {
  readonly " $data"?: UserProfileCardRelay_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfileCardRelay_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
},
v1 = {
  "kind": "ScalarField",
  "name": "picture"
},
v2 = {
  "kind": "ScalarField",
  "name": "jobTitle"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v4/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v4/*: any*/)
    }
  ],
  "type": "ConfluenceBlogPost"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v4/*: any*/)
    }
  ],
  "type": "ConfluenceWhiteboard"
},
v8 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v4/*: any*/)
  },
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ]
  }
],
v9 = [
  {
    "kind": "ScalarField",
    "name": "url"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v11 = [
  (v10/*: any*/)
],
v12 = [
  (v10/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": (v11/*: any*/)
  }
],
v13 = [
  {
    "alias": "trelloUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v14 = [
  {
    "alias": "webUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v15 = [
  {
    "concreteType": "AssetsLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "web"
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orgId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "skipKnowledgeDiscovery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userAri"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userIdString"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "viewerId"
    }
  ],
  "kind": "Fragment",
  "name": "UserProfileCardRelay_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "userId"
        }
      ],
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "email"
            },
            {
              "concreteType": "AtlassianAccountUserExtendedProfile",
              "kind": "LinkedField",
              "name": "extendedProfile",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "department"
                },
                {
                  "kind": "ScalarField",
                  "name": "location"
                },
                {
                  "kind": "ScalarField",
                  "name": "organization"
                }
              ]
            }
          ],
          "type": "AtlassianAccountUser"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "appType"
            }
          ],
          "type": "AppUser"
        }
      ]
    },
    {
      "concreteType": "Activity",
      "kind": "LinkedField",
      "name": "activity",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "fields": [
                {
                  "items": [
                    {
                      "kind": "Variable",
                      "name": "actors.0",
                      "variableName": "userAri"
                    }
                  ],
                  "kind": "ListValue",
                  "name": "actors"
                }
              ],
              "kind": "ObjectValue",
              "name": "filter"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 50
            }
          ],
          "concreteType": "ActivityConnection",
          "kind": "LinkedField",
          "name": "workedOn",
          "plural": false,
          "selections": [
            {
              "concreteType": "ActivityItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "ActivityNode",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "ActivityObject",
                      "kind": "LinkedField",
                      "name": "object",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "data",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v5/*: any*/),
                            (v6/*: any*/),
                            (v7/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "ConfluenceDatabaseLinks",
                                  "kind": "LinkedField",
                                  "name": "links",
                                  "plural": false,
                                  "selections": (v4/*: any*/)
                                }
                              ],
                              "type": "ConfluenceDatabase"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "ConfluenceEmbedLinks",
                                  "kind": "LinkedField",
                                  "name": "links",
                                  "plural": false,
                                  "selections": (v4/*: any*/)
                                }
                              ],
                              "type": "ConfluenceEmbed"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v8/*: any*/),
                              "type": "ConfluenceFooterComment"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v8/*: any*/),
                              "type": "ConfluenceInlineComment"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "TownsquareGoal"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "TownsquareProject"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "TownsquareComment"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v11/*: any*/),
                              "type": "JiraIssue"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v12/*: any*/),
                              "type": "JiraPlatformComment"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v12/*: any*/),
                              "type": "JiraServiceManagementComment"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v13/*: any*/),
                              "type": "TrelloBoard"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v13/*: any*/),
                              "type": "TrelloCard"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v14/*: any*/),
                              "type": "DevOpsDocument"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "ExternalDocument"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "DevOpsPullRequestDetails"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "ExternalPullRequest"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v14/*: any*/),
                              "type": "DevOpsDesign"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "ExternalRemoteLink"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "MercuryFocusArea"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "MercuryPortfolio"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "RadarPosition"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "RadarView"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v9/*: any*/),
                              "type": "CompassComponent"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "href"
                                }
                              ],
                              "type": "BitbucketPullRequest"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "loomUrl",
                                  "kind": "ScalarField",
                                  "name": "url"
                                }
                              ],
                              "type": "LoomVideo"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v15/*: any*/),
                              "type": "AssetsObject"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v15/*: any*/),
                              "type": "AssetsObjectType"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v15/*: any*/),
                              "type": "AssetsSchema"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "condition": "skipKnowledgeDiscovery",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "KnowledgeDiscoveryQueryApi",
          "kind": "LinkedField",
          "name": "knowledgeDiscovery",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "accountId",
                  "variableName": "userIdString"
                },
                {
                  "kind": "Variable",
                  "name": "orgId",
                  "variableName": "orgId"
                },
                {
                  "kind": "Variable",
                  "name": "requestingUserId",
                  "variableName": "viewerId"
                },
                {
                  "kind": "Variable",
                  "name": "tenantId",
                  "variableName": "cloudId"
                }
              ],
              "kind": "LinkedField",
              "name": "singleUser",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "KnowledgeDiscoveryUserProfile",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "KnowledgeDiscoveryUserManager",
                          "kind": "LinkedField",
                          "name": "manager",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "id"
                            },
                            (v2/*: any*/),
                            (v1/*: any*/),
                            (v0/*: any*/)
                          ]
                        },
                        {
                          "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                          "kind": "LinkedField",
                          "name": "thirdPartyIntegrations",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "externalId"
                            },
                            {
                              "kind": "ScalarField",
                              "name": "integrationId"
                            },
                            {
                              "kind": "ScalarField",
                              "name": "product"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "type": "KnowledgeDiscoverySingleUser"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "53886d7197ad4b100ae4ef8f712bf138";

export default node;
